module.exports = __webpack_public_path__ + "static/img/picture1.55570d6f.png";